import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
isLoading;
  constructor() { }

  ngOnInit() {
  }
  onSignup(f: NgForm) {
    console.log(f.value);
  }
}
